export default __webpack_public_path__ + "static/media/nokia.cc9a9476.jpg";